/**
 * Helper function for picking query parameters out of params while still maintaining type safety.
 */
export const extractParams = ([path, params]) => {
    // Extract query params if they exist
    const queryParams = params && 'queryParams' in params ? params.queryParams : undefined;
    // Omit queryParams from params if they exist
    let routeParams = params;
    if (params && 'queryParams' in params) {
        const { queryParams: omittedQueryParams, ...rest } = params;
        routeParams = rest;
    }
    // Coerce Typescript by helping with tuple type
    return [path, routeParams, queryParams];
};
